import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import mySheetLeaveIcon from "@iconify/icons-mdi/bag-personal";
import mySheetIcon from "@iconify/icons-mdi/clipboard-text-clock-outline";
import { InlineIcon } from "@iconify/react";

interface Event {
  id?: string;
  title: string;
}

export const MyTimesheetCalendarMonthEvent = ({ event }: { event: Event }) => {
  const theme = useTheme();
  const isLeaveEvent = event?.id?.startsWith("leave-");

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent={"space-between"}
      alignItems="center"
    >
      <Typography
        noWrap={true}
        variant="caption"
        color={
          isLeaveEvent ? theme.palette.white.main : theme.palette.darkBase.main
        }
      >
        {event.title}
      </Typography>
      <InlineIcon
        icon={isLeaveEvent ? mySheetLeaveIcon : mySheetIcon}
        width="20px"
        height="20px"
        style={{
          color: isLeaveEvent
            ? theme.palette.white.main
            : theme.palette.darkBase.main,
          minWidth: "20px",
        }}
      />
    </Box>
  );
};

export default MyTimesheetCalendarMonthEvent;
